import ajax from '@/utils/request'

// 固件管理列表
export const firmwareList = data => ajax('/api/firmware/get/list/', data, 'POST')
// 新增
export const firmwareAdd = data => ajax('/api/firmware/add/', data, 'POST')
// 删除
export const firmwareDel = data => ajax('/api/firmware/del/', data, 'POST')
// 详情
export const firmwareDetail = data => ajax('/api/firmware/get/', data, 'GET')
// 编辑
export const firmwareUpdate = data => ajax('/api/firmware/update/', data, 'POST')
// 升级管理列表
export const otaList = data => ajax('/api/ota/task/get/list/', data, 'POST')
// 添加升级任务
export const otaAdd = data => ajax('/api/ota/task/add/', data, 'POST')
// 删除升级任务
export const otaDel = data => ajax('/api/ota/task/del/', data, 'POST')
// 发布任务
export const otaPublish = data => ajax('/api/ota/task/publish/', data, 'POST')
// 取消升级
export const otaCancel = data => ajax('/api/ota/task/cancel/', data, 'POST')
// 关联设备
export const upgradeCheckedDeviceList = data => ajax('/api/ota/task/checkedDevice', data, 'POST')
// 解绑升级关联的设备
export const unbindDeviceFromUpgrade = data => ajax('/api/ota/task/unbindDevice', data, 'POST')
// 指定产品型号的版本号
export const firmwareVersion = data => ajax('/api/firmware/get/version/', data, 'GET')
